<div class="flex flex-col gap-4">
  <soft-ds-select [(value)]="selected">
    @for (certificate of possibleCertificates(); track certificate.id) {
      <soft-ds-select-option
        [label]="certificate.number"
        [value]="certificate"
        [item]="{ value: certificate, label: certificate.number }"
        [optionTemplate]="optionTemp"
      />
      <ng-template #optionTemp>
        <div class="flex flex-row justify-between items-end">
          <div class="flex flex-col">
            <span class="font-semibold">{{certificate.number}}</span>
            <span class="text-xs">{{certificate.type.name}}</span>
          </div>
          <span class="text-xs">Prüfdatum: {{certificate.inspectionDate}}</span>
        </div>
      </ng-template>

    }
  </soft-ds-select>

  <soft-ds-quantity-input [(value)]="percentage" [unit]="'%'"/>

  <div class="flex flex-row w-full sm:gap-2">
    <button
      class="soft-button secondary w-1/2 mt-2 h-16"
      (click)="resolve(null)">
      {{'#WWS_WARENUEBERNAHME.DIALOG.LABEL_ABBRECHEN' | translate}}
    </button>
    <button
      class="soft-button primary w-1/2 mt-2 h-16"
      [disabled]="!selected()"
      (click)="submit()">
      {{'#WWS_WARENUEBERNAHME.DIALOG.LABEL_FORTFAHREN' | translate}}
    </button>
  </div>
</div>
